module.exports = __webpack_public_path__ + "static/media/Getty_Images_1188457330_mobile.0ed04c85.jpg";